import internalAPI, { handleInternalAPIError } from './internalAPI';

/**
 * Kick user sync process.
 *
 * @return {void}
 */
export const pushSyncInfo = (): void => {
  internalAPI(true)
    .post('/api/xtremepushSyncInfo', {}, {})
    .catch((error) => {
      console.error('xtremepush error calling internal API');
      return handleInternalAPIError(error);
    });
};
